/**
 * Fade In On Scroll
 * Adds animation to elements when they enter the viewport
 */

export const initFadeInOnScroll = (options = {}) => {
  const defaults = {
    selector: '[data-slide-bottom], [data-slide-left], [data-slide-bottomLeft], [data-slide-top], [data-fade]',
    threshold: 0.2,
    rootMargin: '0px 0px -5% 0px',
    once: true
  };

  const settings = { ...defaults, ...options };
  let observer;
  let elements = [];

  // Get all elements with animation data attributes
  const findElements = () => {
    elements = Array.from(document.querySelectorAll(settings.selector));
    return elements;
  };

  // Handle intersection
  const handleIntersect = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        element.classList.add('fade-in-visible');
        
        // Unobserve if we only want the animation to happen once
        if (settings.once) {
          observer.unobserve(element);
        }
      } else if (!settings.once) {
        // If not using "once" mode, remove the class when out of viewport
        entry.target.classList.remove('fade-in-visible');
      }
    });
  };

  // Setup observer
  const setupObserver = () => {
    if (observer) {
      elements.forEach(element => observer.unobserve(element));
    }
    
    observer = new IntersectionObserver(handleIntersect, {
      threshold: settings.threshold,
      rootMargin: settings.rootMargin
    });
    
    elements.forEach(element => {
      // Initial state is handled by CSS attribute selectors
      observer.observe(element);
    });
  };

  // Initialize
  const init = () => {
    // Find elements and setup observer
    findElements();
    setupObserver();
    
    // Watch for DOM changes
    const mutationObserver = new MutationObserver(() => {
      findElements();
      setupObserver();
    });
    
    mutationObserver.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  };

  // Start the system
  init();

  // Return public API
  return {
    refresh: () => {
      findElements();
      setupObserver();
    }
  };
}; 